import { ReactComponent as Add } from '../Icons/Add.svg';
import { ReactComponent as Apps } from '../Icons/Apps.svg';
import { ReactComponent as ArrowBack } from '../Icons/Arrow_back.svg';
import { ReactComponent as ArrowDown } from '../Icons/Arrow_down.svg';
import { ReactComponent as ArrowForward } from '../Icons/Arrow_forward.svg';
import { ReactComponent as ArrowUp } from '../Icons/Arrow_up.svg';
import { ReactComponent as Auto } from '../Icons/Auto.svg';
import { ReactComponent as Block } from '../Icons/Block.svg';
import { ReactComponent as Cancel } from '../Icons/Cancel.svg';
import { ReactComponent as Check } from '../Icons/Check.svg';
import { ReactComponent as ChevronDown } from '../Icons/Chevron_down.svg';
import { ReactComponent as ChevronLeft } from '../Icons/Chevron_left.svg';
import { ReactComponent as ChevronRight } from '../Icons/Chevron_right.svg';
import { ReactComponent as ChevronUp } from '../Icons/Chevron_up.svg';
import { ReactComponent as CircleAdd } from '../Icons/Circle_add.svg';
import { ReactComponent as CircleCheck } from '../Icons/Circle_check.svg';
import { ReactComponent as CircleError } from '../Icons/Circle_error.svg';
import { ReactComponent as CircleInfo } from '../Icons/Circle_info.svg';
import { ReactComponent as CircleRemove } from '../Icons/Circle_remove.svg';
import { ReactComponent as CircleUser } from '../Icons/Circle_user.svg';
import { ReactComponent as CloudDownload } from '../Icons/Cloud_download.svg';
import { ReactComponent as CloudUpload } from '../Icons/Cloud_upload.svg';
import { ReactComponent as Computer } from '../Icons/Computer.svg';
import { ReactComponent as Copy } from '../Icons/Copy.svg';
import { ReactComponent as Delete } from '../Icons/Delete.svg';
import { ReactComponent as Desktop } from '../Icons/Document.svg';
import { ReactComponent as Document } from '../Icons/Add.svg';
import { ReactComponent as Download } from '../Icons/Download.svg';
import { ReactComponent as Drag } from '../Icons/Drag.svg';
import { ReactComponent as Edit } from '../Icons/Edit.svg';
import { ReactComponent as Expand } from '../Icons/Expand_content.svg';
import { ReactComponent as FullScreen } from '../Icons/Fullscreen.svg';
import { ReactComponent as Group } from '../Icons/Group.svg';
import { ReactComponent as Heart } from '../Icons/Heart.svg';
import { ReactComponent as Home } from '../Icons/Home.svg';
import { ReactComponent as Info } from '../Icons/Info.svg';
import { ReactComponent as LightBulb } from '../Icons/Lightbulb.svg';
import { ReactComponent as Lightning } from '../Icons/Lightning.svg';
import { ReactComponent as ListFilter } from '../Icons/List_filter.svg';
import { ReactComponent as ListSort } from '../Icons/List_sort.svg';
import { ReactComponent as Loader } from '../Icons/Loader.svg';
import { ReactComponent as Login } from '../Icons/Logout.svg';
import { ReactComponent as Logout } from '../Icons/Logout.svg';
import { ReactComponent as Menu } from '../Icons/Menu.svg';
import { ReactComponent as Minimize } from '../Icons/Minimize.svg';
import { ReactComponent as Move } from '../Icons/Move.svg';
import { ReactComponent as MoreHorizontal } from '../Icons/More_horizontal.svg';
import { ReactComponent as MoreVertical } from '../Icons/More_vertical.svg';
import { ReactComponent as Node } from '../Icons/Node.svg';
import { ReactComponent as Power } from '../Icons/Power.svg';
import { ReactComponent as Refresh } from '../Icons/Refresh.svg';
import { ReactComponent as Remove } from '../Icons/Remove.svg';
import { ReactComponent as Search } from '../Icons/Search.svg';
import { ReactComponent as Separate } from '../Icons/Separate.svg';
import { ReactComponent as Settings } from '../Icons/Settings.svg';
import { ReactComponent as SignalOff } from '../Icons/Signal_off.svg';
import { ReactComponent as SortDown } from '../Icons/Sort_down.svg';
import { ReactComponent as SortUp } from '../Icons/Sort_up.svg';
import { ReactComponent as Sort } from '../Icons/Sort.svg';
import { ReactComponent as Star } from '../Icons/Star.svg';
import { ReactComponent as Sync } from '../Icons/Sync.svg';
import { ReactComponent as Target } from '../Icons/Target.svg';
import { ReactComponent as ThumpUp } from '../Icons/Thumb_up.svg';
import { ReactComponent as ThumpDown } from '../Icons/Thumb_down.svg';
import { ReactComponent as Tower } from '../Icons/Tower.svg';
import { ReactComponent as Tune } from '../Icons/Tune.svg';
import { ReactComponent as Undo } from '../Icons/Undo.svg';
import { ReactComponent as Update } from '../Icons/Update.svg';
import { ReactComponent as Upload } from '../Icons/Upload.svg';
import { ReactComponent as User } from '../Icons/User.svg';
import { ReactComponent as UserOff } from '../Icons/User_off.svg';
import { ReactComponent as Warning } from '../Icons/Warning.svg';

const Icons = {
    Add,
    Apps,
    ArrowBack,
    ArrowDown,
    ArrowForward,
    ArrowUp,
    Auto,
    Block,
    Cancel,
    Check,
    ChevronDown,
    ChevronLeft,
    ChevronRight,
    ChevronUp,
    CircleAdd,
    CircleCheck,
    CircleError,
    CircleInfo,
    CircleRemove,
    CircleUser,
    CloudDownload,
    CloudUpload,
    Computer,
    Copy,
    Delete,
    Desktop,
    Document,
    Download,
    Drag,
    Edit,
    Expand,
    FullScreen,
    Group,
    Heart,
    Home,
    Info,
    LightBulb,
    Lightning,
    ListFilter,
    ListSort,
    Loader,
    Login,
    Logout,
    Menu,
    Minimize,
    Move,
    MoreHorizontal,
    MoreVertical,
    Node,
    Power,
    Refresh,
    Remove,
    Search,
    Separate,
    Settings,
    SignalOff,
    Sort,
    SortDown,
    SortUp,
    Star,
    Sync,
    Target,
    ThumpDown,
    ThumpUp,
    Tower,
    Tune,
    Undo,
    Update,
    Upload,
    User,
    UserOff,
    Warning
};

export default Icons;
